import { lang } from '@lang';
import { Trash2 } from 'lucide-react';
import { useDesign } from '@hooks';

import { Feature } from '..';
import { selectPromotionalDescription, setPromotionalDescription, useAppDispatch, useAppSelector } from '@state';


export const useChangeDescriptionPromotionalSkuFeature = (): Feature<string> => {
	const [controller] = useDesign();
	const dispatch = useAppDispatch();

	const kitchen = controller?.kitchen ?? null;
	const descriptionPromotionalSku = useAppSelector(selectPromotionalDescription);
	return {
		name: 'remove-promotional-sku',
		label: lang.promotionalSku.label.delete,
		shortcut: '',
		tooltip: lang.promotionalSku.tooltip.deleteSku,
		icon: (props = {}) => <Trash2 {...props} />,
		disabled: false,
		value: '',
		hidden: false,
		handler: () => {
			const [sku, description] = descriptionPromotionalSku;
			const promotionalSku = kitchen?.promotionalSkus.findBySku(sku);
			if (promotionalSku) {
				promotionalSku.description = description;
			}

			dispatch(setPromotionalDescription([]));
		}
	};
};
